import TeacherModality from './TeacherModality';

export default TeacherModality;
